import image1 from "../assets/t-image1.jpeg";
import image2 from "../assets/t-image2.jpeg";
import image3 from "../assets/t-image3.jpeg";
import image4 from "../assets/t-image4.jpeg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing Morsy as a coach as he helped me to reach my goal",
    name: "Marwan Ahmed",
    status: "Lawyer",
  },
  {
    image: image2,
    review:
      "Coach morsy always listens and provides the best plan that suits me better",
    name: "Eslam Abo El-enien",
    status: "Pharmacist",
  },
  {
    image: image3,
    review:
      " I was surprised about the resulting month after month and I love the fact that he follows me all day whenever I have a question",
    name: "Hussein Talal",
    status: "Accountant",
  },
  {
    image: image4,
    review:
      " Always convinces me with his logical answers and he communicates in a very professional and friendly way",
    name: "Ahmed Ramzy",
    status: "Engineer",
  },
];
